import React, { useState, useEffect } from "react";
import "../styles/Hero.css";
import heroImg1 from "../pictures/Meeting.jpg";
import heroImg2 from "../pictures/Teamwork.jpg";
import heroImg3 from "../pictures/Presentation.jpg";

const Hero = () => {
  const slides = [
    {
      image: heroImg1,
      title: "Empowering Your Business",
      text: "We help you achieve your goals with expert strategies.",
      buttonText: "Learn More",
      buttonLink: "#services",
    },
    {
      image: heroImg2,
      title: "Teamwork for Success",
      text: "Collaboration that delivers results.",
      buttonText: "Our Team",
      buttonLink: "#about",
    },
    {
      image: heroImg3,
      title: "Innovative Solutions",
      text: "Modern strategies for modern challenges.",
      buttonText: "Get Started",
      buttonLink: "#contact",
    },
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="hero" id="home">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`hero-slide ${index === current ? "active" : ""}`}
        >
          <div className="hero-img-container">
            <div
              className="hero-bg"
              style={{ backgroundImage: `url(${slide.image})` }}
            ></div>

            <img src={slide.image} alt={slide.title} className="hero-img" />

            <div className="hero-overlay">
              <h1>{slide.title}</h1>
              <p>{slide.text}</p>
              <a href={slide.buttonLink} className="hero-btn">
                {slide.buttonText}
              </a>
            </div>
          </div>
        </div>
      ))}

      {/* 🔘 Slide Indicators */}
      <div className="hero-indicators">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === current ? "active" : ""}`}
            onClick={() => setCurrent(index)}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default Hero;
